import { useMutation } from "@tanstack/react-query";
import { appInfo } from "..";

function useUpdateImei() {
  return useMutation({
    mutationFn: appInfo.updateAppInfoUpdate,
  });
}

export default useUpdateImei;
